import {
  Loader,
  DeltaBadge,
  BreakdownTable,
  PerkSparkline,
  fillDailySeries,
  useReport,
  ExportCsvButton,
} from "../shared";

export const PerkRedemptionsSection = ({ filter }) => {
  const [data, loading, prevData] = useReport("/reports/perk-redemptions", filter, false);
  if (loading) return <Loader />;
  if (!data) return null;
  return (
    <div className="space-y-4" data-testid="perks-section">
      <div className="flex justify-end">
        <ExportCsvButton
          path="/reports/perk-redemptions/export.csv"
          filter={filter}
          isSingleDay={false}
          testId="export-perks-csv"
        />
      </div>
      {data.total_redemptions > 0 && (
        <PerkSparkline points={fillDailySeries(data.timeseries, data.start_date, data.end_date)} />
      )}
      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-lg border border-border p-3" data-testid="perk-report-total-count">
          <div className="text-xs uppercase text-muted-foreground">Redemptions</div>
          <div className="text-2xl font-mono font-semibold">{data.total_redemptions}</div>
          {prevData ? (
            <div className="mt-1">
              <DeltaBadge current={data.total_redemptions} previous={prevData.total_redemptions} />
            </div>
          ) : null}
        </div>
        <div className="rounded-lg border border-border p-3" data-testid="perk-report-total-amount">
          <div className="text-xs uppercase text-muted-foreground">Given Away</div>
          <div className="text-2xl font-mono font-semibold text-accent">
            ${data.total_amount.toFixed(2)}
          </div>
          {prevData ? (
            <div className="mt-1">
              <DeltaBadge current={data.total_amount} previous={prevData.total_amount} />
            </div>
          ) : null}
        </div>
      </div>
      {data.total_redemptions === 0 ? (
        <div
          className="py-8 text-center text-sm text-muted-foreground rounded-lg bg-secondary/30"
          data-testid="perk-report-empty"
        >
          No perk redemptions in this window yet.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <BreakdownTable title="By Perk" rows={data.by_perk} testIdPrefix="perk-report-by-perk" />
          <BreakdownTable
            title="By Cashier"
            rows={data.by_cashier}
            testIdPrefix="perk-report-by-cashier"
          />
        </div>
      )}
    </div>
  );
};
